import { BrandIcon, BrandIconId, BrandIconSize } from '@ampcore/adel-react'
import { AnalyticsTagBuilder } from '@dai-team/analytics-library'
import React, { useMemo } from 'react'
import xss from 'xss'

import { Link } from '../../types/Link.type'
import { MostVisitedLinksIcons } from './MostVisitedLinksIcons'

export type MostVisitedLinksMenuItems = Link & {
  icon: BrandIconId
}

export type MostVisitedLinksProps = {
  menuItems: MostVisitedLinksMenuItems[]
  heading: string
  isEnabled?: boolean
  testId?: string
}

export const MostVisitedLinks = (props: MostVisitedLinksProps) => {
  const { heading, menuItems, isEnabled, testId } = props

  const atb = useMemo(
    () => new AnalyticsTagBuilder().setDefaultName('SearchMostVisitedLinks'),
    []
  )

  if (!isEnabled) {
    return null
  }

  return (
    <>
      <MostVisitedLinksIcons />
      <div
        className="MostVisitedLinks"
        data-testid={testId ? `${testId}` : null}
      >
        <div className="u-sm-hidden">
          <h4
            className="u-textBold u-textCenter u-marginBottom32"
            data-testid={testId ? `${testId}-heading-desktop` : null}
            dangerouslySetInnerHTML={{ __html: xss(heading) }}
          />
          <div className="u-flex u-flex-row u-flexJustifyCenter u-marginHoriz16">
            {menuItems.map((menuItems, index) => (
              <a
                key={index}
                className="u-textCenter u-marginRight32"
                href={xss(menuItems.url)}
                aria-label={`Read more about ${menuItems.name}`}
                data-testid={testId ? `${testId}-link-desktop-${index}` : null}
                {...atb.dataAnalyticAttribute()}
              >
                <div className="u-marginBottom4">
                  <BrandIcon
                    icon={menuItems.icon}
                    size={BrandIconSize.SMALL}
                    style={{ fill: '#003f6b' }}
                    spriteUrl={''}
                    testId={`icon-${testId}-${index}`}
                  />
                </div>
                <span
                  className="u-flexWrap"
                  dangerouslySetInnerHTML={{ __html: xss(menuItems.name) }}
                />
              </a>
            ))}
          </div>
        </div>
        <div className="u-md-hidden u-lg-hidden">
          <h4
            className="u-textBold u-marginBottom32"
            data-testid={testId ? `${testId}-heading-desktop` : null}
            dangerouslySetInnerHTML={{ __html: xss(heading) }}
          />
          {menuItems.map((menuItems, index) => (
            <div key={index} className="u-marginTop20 u-flex u-flex-row ">
              <a
                href={xss(menuItems.url)}
                className="u-textSizeMsr"
                aria-label={`Read more about ${menuItems.name}`}
                {...atb.dataAnalyticAttribute()}
                data-testid={testId ? `${testId}-link-mobile-${index}` : null}
                dangerouslySetInnerHTML={{ __html: xss(menuItems.name) }}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
